import { render, staticRenderFns } from "./VPasswordReset.vue?vue&type=template&id=d74c7480&lang=pug"
import script from "./VPasswordReset.vue?vue&type=script&lang=ts"
export * from "./VPasswordReset.vue?vue&type=script&lang=ts"
import style0 from "./VPasswordReset.vue?vue&type=style&index=0&id=d74c7480&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports